import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
    marginBottom: theme.spacing(1.5),
  },
  gridList: {
    width: 800,
    // height: 450,
  },
  img: {
    transition: 'transform 1s, filter 1s ease-in-out',
    filter: 'blur(2px)',
    '&:hover': {
      filter: 'blur(0)',
    }
  }
}));


/**
 * The example data is structured as follows:
 *
 * import image from 'path/to/image.jpg';
 * [etc...]
 *
 */
const tileData = [
  {
    img: '/image/1.jpeg',
    title: 'Image',
    author: 'author',
    featured: true,
    cols: 1,
  },
  {
    img: '/image/2.jpeg',
    title: 'Image',
    author: 'author',
    featured: true,
    cols: 2,
  },
  {
    img: '/image/3.jpeg',
    title: 'Image',
    author: 'author',
    featured: true,
    cols: 2,
  },
  {
    img: '/image/about.jpeg',
    title: 'Image',
    author: 'author',
    featured: true,
  },
  {
    img: '/image/1.jpeg',
    title: 'Image',
    author: 'author',
    featured: true,
    cols: 3,
  },
];

export default function GridGallery() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <GridList cellHeight={160} className={classes.gridList} cols={3}>
        {tileData.map((tile, index) => (
          <GridListTile key={`tile.img-${index}`} cols={tile.cols || 1}>
            <img src={tile.img} alt={tile.title} className={classes.img} />
          </GridListTile>
        ))}
      </GridList>
    </div>
  );
}